<template>
    <div class="flex flex-row justify-between xl:w-4/6 items-end">
        <h1 class="no-margins text-mimer-turquoise mb-4">
            {{ currentApartment.postalAddress }}
        </h1>
        <img
            class="mb-4 energy-declaration"
            v-if="energyDeclaration"
            :src="getEnergyDeclarationImg(energyDeclaration)" />
    </div>

    <div class="flex flex-col xl:flex-row pb-4 xl:pb-0">
        <div class="w-full xl:w-4/6">
            <div v-if="images.length === 0" class="md:h-96">
                <img class="h-full p-8 mx-auto" src="../../assets/undraw_car.svg" alt="" />
            </div>
            <div v-if="images.length > 0" class="md:h-96 overflow-hidden flex items-center justify-center">
                <img
                    v-on:click="toggleFullScreen()"
                    class="w-full cursor-pointer object-center ease-in-out duration-300"
                    :src="images[imgIndex].url"
                    alt="Bild av bostaden" />
            </div>
            <div v-if="images.length > 1" class="flex flex-row justify-between items-center p-4">
                <div
                    v-on:click="decreaseImgIndex()"
                    class="border border-gray-300 rounded-full p-4 text-center cursor-pointer hover:scale-105">
                    <svg xmlns="http://www.w3.org/2000/svg" id="Bold" viewBox="0 0 24 24" width="24" height="24">
                        <path
                            d="M17.921,1.505a1.5,1.5,0,0,1-.44,1.06L9.809,10.237a2.5,2.5,0,0,0,0,3.536l7.662,7.662a1.5,1.5,0,0,1-2.121,2.121L7.688,15.9a5.506,5.506,0,0,1,0-7.779L15.36.444a1.5,1.5,0,0,1,2.561,1.061Z" />
                    </svg>
                </div>
                <div
                    v-on:click="increaseImgIndex()"
                    class="border border-gray-300 rounded-full p-4 text-center cursor-pointer hover:scale-105">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        xmlns:svgjs="http://svgjs.com/svgjs"
                        version="1.1"
                        width="24"
                        height="24"
                        x="0"
                        y="0"
                        viewBox="0 0 24 24"
                        style="enable-background: new 0 0 512 512"
                        xml:space="preserve">
                        <g>
                            <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="M6.079,22.5a1.5,1.5,0,0,1,.44-1.06l7.672-7.672a2.5,2.5,0,0,0,0-3.536L6.529,2.565A1.5,1.5,0,0,1,8.65.444l7.662,7.661a5.506,5.506,0,0,1,0,7.779L8.64,23.556A1.5,1.5,0,0,1,6.079,22.5Z"
                                fill="#000000"
                                data-original="#000000" />
                        </g>
                    </svg>
                </div>
            </div>
        </div>

        <div
            class="flex xl:h-96 flex-row w-full xl:w-2/6 xl:bg-gray-100 items-center text-sm md:text-base justify-center"
            style="font-size: 0.9rem">
            <div class="pr-2 font-bold text-right border-r border-black">
                <p v-if="currentApartment.postalAddress" class="py-0">Adress</p>
                <p v-if="currentApartment.district" class="py-0">Område</p>
                <p v-if="currentApartment.realEstateObjectTypeCaption" class="py-0">Rum</p>
                <p v-if="currentApartment.size" class="py-0">Yta</p>
                <p v-if="currentApartment.monthRent" class="py-0">Hyra</p>
                <p v-if="currentApartment.stairCase" class="py-0">Våning</p>
                <p v-if="currentApartment.vacantFrom" class="py-0">Inflyttning</p>
                <p v-if="currentApartment.tags.length > 0" class="py-0">Typ</p>
                <p class="py-0">Hiss</p>
                <p v-if="currentApartment.buildingYear" class="py-0">Byggnadsår</p>
                <p v-if="currentApartment.rentalObjectCode" class="py-0">Objektsnummer</p>
            </div>
            <div class="pl-2">
                <p v-if="currentApartment.postalAddress" class="py-0">
                    {{ currentApartment.postalAddress }}
                </p>
                <p v-if="currentApartment.district" class="py-0">
                    {{ currentApartment.district }}
                </p>
                <p v-if="currentApartment.realEstateObjectTypeCaption" class="py-0">
                    {{ currentApartment.realEstateObjectTypeCaption }}
                </p>
                <p v-if="currentApartment.size" class="py-0">{{ currentApartment.size }} m²</p>
                <p v-if="currentApartment.monthRent" class="py-0">
                    {{ Math.round(currentApartment.monthRent.replace(',', '.')) }}
                    kr/månad
                </p>
                <p v-if="currentApartment.stairCase" class="py-0">
                    {{ currentApartment.stairCase }}
                </p>
                <p v-if="currentApartment.vacantFrom" class="py-0">
                    {{
                        new Date().toISOString() >= currentApartment.vacantFrom
                            ? 'Omgående'
                            : currentApartment.vacantFrom.split('T')[0]
                    }}
                </p>
                <p v-if="currentApartment.tags" class="py-0">
                    {{ currentApartment.tags.join(', ') }}
                </p>
                <p class="py-0">
                    {{ currentApartment.elevatorExists ? 'Ja' : 'Nej' }}
                </p>
                <p v-if="currentApartment.buildingYear" class="py-0">
                    {{ currentApartment.buildingYear }}
                </p>
                <p v-if="currentApartment.rentalObjectCode" class="py-0">
                    {{ currentApartment.rentalObjectCode }}
                </p>
            </div>
        </div>
    </div>

    <div v-if="fullScreen" class="fixed z-50 overflow-scroll bg-black/80 w-screen h-screen top-0 left-0">
        <div class="fixed w-full flex justify-end text-white text-5xl p-6">
            <div v-on:click="toggleFullScreen()" class="cursor-pointer hover:scale-105">✕</div>
        </div>
        <div class="p-8"></div>
        <div class="cursor-default" v-for="(image, imgIndex) in images" :key="imgIndex">
            <img class="max-h-[70%] mx-auto my-6" :src="image.url" alt="" />
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps } from 'vue';
import axios from 'axios';
import { loggedInStatus } from '../../utils/helpers';

const props = defineProps({
    currentApartment: {
        type: Object,
        required: true,
    },
});

const imgIndex = ref(0);
const fullScreen = ref(false);
const images = props.currentApartment.imageUrlList.filter((image) => image.caption == 'Building');
const energyDeclaration = ref(null);

const decreaseImgIndex = () => {
    if (imgIndex.value == 0) {
        imgIndex.value = images.length - 1;
    } else if (imgIndex.value > 0) {
        imgIndex.value = imgIndex.value - 1;
    }
};

const increaseImgIndex = () => {
    if (imgIndex.value == images.length - 1) {
        imgIndex.value = 0;
    } else if (imgIndex.value < images.length - 1) {
        imgIndex.value = imgIndex.value + 1;
    }
};

const toggleFullScreen = () => (fullScreen.value = !fullScreen.value);

const getEnergyDeclarationImg = (img) => require(`../../assets/energideklaration/${img}.jpg`);

const fetchEnergyDeclaration = async () => {
    try {
        const { block, postalAddress } = props.currentApartment;
        if (block && postalAddress) {
            let energyDeclarationResp = await axios.post(
                process.env.VUE_APP_API_URL + '/api/publishedRentalObjects/energydeclaration/',
                {
                    Municipality: 'Västerås',
                    PropertyDesignation: block,
                    Address: postalAddress,
                },
                {
                    headers: {
                        Authorization: `Bearer ${loggedInStatus()}`,
                    },
                }
            );

            if (energyDeclarationResp.status === 200) {
                const energiklass = energyDeclarationResp.data.energiklass;

                if (energiklass) {
                    energyDeclaration.value = energiklass;
                } else {
                    console.log('Objekt saknar energiklassning.');
                }
            }
        } else {
            console.log('One or more required fields are empty or null.');
        }
    } catch (err) {
        console.error('Failed to fetch energy declaration:', err);
        return err;
    }
};
fetchEnergyDeclaration();
</script>
